import React from "react";
import "./ScanArea.css";
import {
  Switch, Tooltip, Input, Skeleton, Button,
} from "antd";
import qrCode from "../../../../assets/images/overhaul/images/QRCode.png";

function ScanArea({
  qrData,
  setQrData,
  qrInputRef,
  setCleanChecked,
  setTntcChecked,
  cleanChecked,
  tntcChecked,
  showCountsModal,
  scanningLoading,
  handleFetchHierarchyFailedSamples,
}) {
  /**
   * Handles clean and tntc toggle. Both cannot be on at the same time.
   * @param {"clean" | "tntc"} type
   * @param {Boolean} checked if toggle is on or off
   */
  const onToggleChange = (type, checked) => {
    if (type === "clean") {
      if (checked && tntcChecked) {
        setTntcChecked(false);
      }
      setCleanChecked(checked);
    } else if (type === "tntc") {
      if (checked && cleanChecked) {
        setCleanChecked(false);
      }
      setTntcChecked(checked);
    }
  };
  return (
    <>
      <div className="ScanArea__TopSection">
        <span className="ScanArea__Title">Using the QR scanner, scan the QR code on the Petrifilm</span>
        <Tooltip
          placement="bottom"
          title="Click here when you are done with counts for today."
        >
          <Button
            type="primary"
            onClick={handleFetchHierarchyFailedSamples}
          >
            Migrate
          </Button>
        </Tooltip>
      </div>
      <div className="ScanArea__Container">
        <div className="ScanArea">
          <img src={qrCode} alt="QR Code" className="ScanArea__QRCodeImg" />
          {scanningLoading ? (
            <Skeleton.Input className="ScanArea__Loading" active />
          )
            : (
              <Input.TextArea
                className="ScanArea__ScannerInput"
                autoFocus
                ref={qrInputRef}
                value={qrData}
                onChange={(e) => setQrData(e.target.value)}
                onBlur={() => { if (!showCountsModal) { qrInputRef.current.focus(); } }}
                autoSize={{ minRows: 4, maxRows: 4 }}
              />
            )}
        </div>
        <div className="ScanArea__SwitchParent">
          <Tooltip
            placement="bottomRight"
            title="This will auto send the default raw count value of 0."
          >
            <div className="ScanArea__Switch">
              <span>Clean</span>
              <Switch
                checked={cleanChecked}
                onChange={(checked) => onToggleChange("clean", checked)}
              />
            </div>
          </Tooltip>
          <Tooltip
            placement="bottomRight"
            title=""
          >
            <div className="ScanArea__Switch">
              <span>TNTC</span>
              <Switch
                checked={tntcChecked}
                onChange={(checked) => onToggleChange("tntc", checked)}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  );
}

export default ScanArea;
